var jsonData = null;
var cardCache = {};
var initialColumn = $('[data-whatson-cta-initial]');
var resultsColumn = $('[data-whatson-cta-results]');
var resultsSlider = $('.whats-on-slider');
var whatsonSlider = window.whatsonSlider;

$(function () {

    fetchWhatsOnData();

});


function preloadCards(callback) {
    var preloadIndex = 0;

    function preloadNextCard() {
        if (preloadIndex < jsonData.length) {
            var item = jsonData[preloadIndex];
            cardCache[item.id] = item.html;
            preloadIndex++;
            preloadNextCard();
        } else {
            callback(); // Continue with the main logic after preloading
        }
    }

    preloadNextCard();
}


$('[data-whatson-cta-filter]').on("click", function(e) {
    $('[data-whatson-cta-filter]').removeClass('btn-fill');
    $(this).addClass('btn-fill');
    var section = $(this).attr('data-section');
    console.log('section ' + section);
    if (section == 'all') {
        var filtered = jsonData;
    } else {
        var filtered = jsonData.filter(item => item.section.includes(section));
    }
    filtered = filtered.slice(0, 6);
    console.log(filtered)

    $('.whats-on-section .row-cards-desktop').find('.card').each(function (index) {
        setTimeout(() => {
            $(this).addClass('hiding');
        }, (index + 1) * 50);
    });

    whatsonSlider.removeAllSlides();

    setTimeout(() => {
        initialColumn.height(initialColumn.height());
        resultsColumn.empty();
        appendFilteredCards(0, filtered);
    }, 200);


});


function appendFilteredCards(index, filtered) {
    console.log('index ' + index)
    if (index < filtered.length) {
        var item = filtered[index];
        console.log(item.id)
        if (cardCache[item.id]) {
            console.log('cached!')
            var card = cardCache[item.id].replace('"card"', '"card hiding"');
            resultsColumn.append(card);
            
            whatsonSlider.appendSlide('<div class="swiper-slide">' + card + '</div>');
            resultsSlider.find('.card[data-id="' + item.id + '"]').removeClass('hiding');
            // resultsSlider.find('.card[data-id="' + item.id + '"]').parent().addClass('adjust-height');

            setTimeout(() => {
                resultsColumn.find('.card[data-id="' + item.id + '"]').removeClass('hiding');
            }, 50 * index);
            appendFilteredCards(index + 1, filtered);
        } 
    } else {
        initialColumn.height(resultsColumn.height());
    }
}

async function fetchWhatsOnData() {
    if (jsonData === null) {

        // console.log('Fetching whatson-listing.json...');
        
        try {
            const response = await $.ajax({
                type: 'get',
                url: '/whatson-listing.json?&location=all&price=all&category=all&sort=recent&callout=true',
            });
            
            // console.log('success whatson-listing.json');
            jsonData = response.data;
            // console.log(jsonData);

            // Load cards into cache after fetching data
            preloadCards(function () {
                // console.log("All cards preloaded.");
                // Add any additional initialization logic here
            });


        } catch (error) {
            console.log('error whatson-listing.json');
            console.log(error);
        }
    }
}